(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const desktop = matchMedia('(min-width: 990px)');
  const hover = matchMedia('(hover: hover)');
  function close(details) {
    details.open = false;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
  function initialise() {
    document.querySelectorAll('.header__inline-menu .tanwa-brand-menu').forEach(details => {
      if (details.dataset.tanwaBrandReady) return;
      const summary = details.querySelector('summary');
      if (!summary) return;
      details.dataset.tanwaBrandReady = 'true';
      summary.setAttribute('aria-expanded', String(details.open));
      let timer;
      let hoverOpened = false;
      let mouseInside = false;
      function scheduleClose() {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!mouseInside && !details.contains(document.activeElement)) close(details);
        }, 180);
      }
      summary.addEventListener('click', event => {
        if (hoverOpened && details.open && event.detail > 0) {
          event.preventDefault();
          hoverOpened = false;
        }
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (!details.open) hoverOpened = false;
        if (details.open) document.querySelectorAll('.header__inline-menu details[open]').forEach(other => {
          if (other !== details) close(other);
        });
      });
      details.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        mouseInside = true;
        clearTimeout(timer);
        if (desktop.matches && hover.matches && !details.open) {
          details.open = true;
          hoverOpened = true;
        }
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        mouseInside = false;
        scheduleClose();
      });
      details.addEventListener('focusout', scheduleClose);
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          clearTimeout(timer);
          close(details);
          summary.focus();
        }
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.header__inline-menu .tanwa-brand-menu[open]').forEach(details => {
      if (!details.contains(event.target)) close(details);
    });
  });
  desktop.addEventListener('change', () => {
    if (!desktop.matches) document.querySelectorAll('.tanwa-brand-menu[open]').forEach(close);
  });
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
(() => {
  const desktop = matchMedia('(min-width: 990px)');
  const hover = matchMedia('(hover: hover)');
  function close(details) {
    details.open = false;
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
  function initialise() {
    document.querySelectorAll('.header__inline-menu .tanwa-blog-menu').forEach(details => {
      if (details.dataset.tanwaBlogReady) return;
      const summary = details.querySelector('summary');
      if (!summary) return;
      details.dataset.tanwaBlogReady = 'true';
      summary.setAttribute('aria-expanded', String(details.open));
      let timer;
      let hoverOpened = false;
      let mouseInside = false;
      function scheduleClose() {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!mouseInside && !details.contains(document.activeElement)) close(details);
        }, 180);
      }
      summary.addEventListener('click', event => {
        if (hoverOpened && details.open && event.detail > 0) {
          event.preventDefault();
          hoverOpened = false;
        }
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (!details.open) hoverOpened = false;
        if (details.open) document.querySelectorAll('.header__inline-menu details[open]').forEach(other => {
          if (other !== details) close(other);
        });
      });
      details.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        mouseInside = true;
        clearTimeout(timer);
        if (desktop.matches && hover.matches && !details.open) {
          details.open = true;
          hoverOpened = true;
        }
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        mouseInside = false;
        scheduleClose();
      });
      details.addEventListener('focusout', scheduleClose);
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          clearTimeout(timer);
          close(details);
          summary.focus();
        }
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.header__inline-menu .tanwa-blog-menu[open]').forEach(details => {
      if (!details.contains(event.target)) close(details);
    });
  });
  desktop.addEventListener('change', () => {
    if (!desktop.matches) document.querySelectorAll('.tanwa-blog-menu[open]').forEach(close);
  });
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
  } catch(e) { console.error(e); }
})();

})();
